import { apiZoho } from '#plugins/axios.js';

export const registerNovelty = async (data) => {
  const response = await apiZoho.post('/Novedades_Catalogo_Tecnosuper', data);

  return response.data;
};

export const getNoveltyByDate = async (date, doc) => {
  const response = await apiZoho.get('Novedades_Catalogo_Tecnosuper_Report', {
    params: {
      where: `Fecha=="${date}"&&Clientes.Documento=="${doc}"`,
    },
  });

  return response.data.data[0];
};
